export function config($stateProvider) {
  $stateProvider.state('index.customercare.customer.associateservices', {
    url: '/household/associateServices',
    template: '<associate-services></associate-services>'
  });
}